import React from "react";
import { Box, Grid, InputLabel } from "@mui/material";
import AvatarPanel from "./AvatarPanel.tsx";
import MemoryRow from "./MemoryRow.tsx";
import { Trans } from "@lingui/react/macro";

interface ShowMemoriesProps {
  children?: React.ReactNode;
  content: Array<any>;
  role: string;
}

const ShowMemories: React.FC<ShowMemoriesProps> = (props) => {
  return (
    <Box marginBottom={"10%"}>
      <Grid
        container
        direction="row"
        spacing={2}
        alignContent="flex-start"
        alignItems="flex-start"
      >
        <Grid size={{ xs: 1, lg: 1 }}>
          <AvatarPanel />
        </Grid>
        <Grid size={{ xs: 11, lg: 11 }}>
          <InputLabel sx={{ marginBottom: "3%", marginTop: "1.5%" }}>
            <Trans context={"Input label listing all the memories of the user"}>
              Here is a list of your memories
            </Trans>
          </InputLabel>
          {props.content.map((item, index) => (
            <Box key={index}>
              <MemoryRow index={index + 1} memory={item.memory} id={item.id} />
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ShowMemories;
